import React from 'react';
import { SkBox, SkText } from '../../components/SkeletonLoader/SkeletonLoader';
import styles from './ClientesPageSkeleton.module.css';

const COL_WIDTHS = [40, 180, 140, 120, 100, 40, 100, 160, 70];

const TableRowSk: React.FC = () => (
  <div className={styles.row}>
    {COL_WIDTHS.map((w, i) => (
      <SkText key={i} width={w} height={13} style={{ flexShrink: 0 }} />
    ))}
  </div>
);

const ClientesPageSkeleton: React.FC = () => (
  <div className={styles.skeletonWrapper}>
    <div className={styles.tableCard}>
      {/* 10 rows */}
      {Array.from({ length: 10 }).map((_, i) => <TableRowSk key={i} />)}
    </div>
  </div>
);

export default ClientesPageSkeleton;
